import { useState } from "react";
import style from "./index.module.scss";

interface CountdownProps {
  onFinish?: Function;
}

const Countdown = (props: CountdownProps) => {
  const { onFinish } = props;

  const [count, setCount] = useState(59);

  setTimeout(() => {
    if (count === 1) {
      onFinish?.();
      return;
    }
    setCount(count - 1);
  }, 1000);

  return <div className={style.countdown}>{count}</div>;
};

export default Countdown;
